module.exports = __webpack_public_path__ + "img/logo_madera.d14d6fc7.png";